<template>
  <div class="container">
    <div
      class="breadcrumb-cont"
      v-if="_.size(breadCrumbs) && _.size(breadCrumbs) > 1"
    >
      <div class="crumb" v-for="(crumb, index) in breadCrumbs" :key="index">
        <router-link
          v-if="_.get(crumb, 'title') && _.get(crumb, 'full_url')"
          :to="crumb.full_url"
          class="tbc-bold font-12"
          >{{ crumb.title }}</router-link
        >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11.414"
          height="6.207"
          viewBox="0 0 11.414 6.207"
        >
          <path
            id="Path"
            d="M0,0,5,5l5-5"
            transform="translate(0.707 0.707)"
            fill="none"
            stroke="#ffffff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Main from "../mixins/main";
export default {
  name: "breadcrumb",
  mixins: [Main],
  data() {
    return {
      crumbs: [
        { id: 1, title: "HomePage" },
        { id: 2, title: "Offers & More" }
      ]
    };
  },
  computed: {
    breadCrumbs() {
      let res = this.getBreadCrumbs(this.$store.state.main.selected_menu);

      res[0].full_url += "/overview";
      return res;
    }
  }
};
</script>

<style scoped>
.breadcrumb-cont >>> .crumb.router-link-active {
  color: var(--tbc-blue);
}
.breadcrumb-cont {
  display: flex;
  position: absolute;
  z-index: 99;
  top: 32px;
}
.breadcrumb-cont .crumb:not(:first-child) {
  margin-left: 15px;
}
.breadcrumb-cont .crumb svg {
  margin-left: 19px;
  width: 8px;
  margin-bottom: 1px;
  transform: rotate(-90deg);
}
.breadcrumb-cont .crumb svg path {
  stroke-width: 2;
}
.breadcrumb-cont .crumb:last-child svg {
  display: none;
}
.breadcrumb-cont .crumb a {
  color: rgba(255, 255, 255, 0.5);
  transition: 0.3s;
}
.dark .crumb a {
  color: var(--secondary);
  transition: 0.3s;
}
.crumb svg path {
  stroke: #949596;
}
.breadcrumb-cont .crumb a:hover {
  color: var(--tbc-blue);
}
.breadcrumb-cont .crumb a {
  text-transform: capitalize;
}
</style>
